import * as React from 'react';

interface Props {
    title?: string;
    value?: string;
    fontSize?: number;
    color?: string;
}

export class BalanceValue extends React.Component<Props, {}> {

    private style = {
        title: {
            fontSize: this.props.fontSize || 24,
            color: this.props.color
        },
        text: {
            fontSize: this.props.fontSize || 24,
            color: this.props.color
        },
    }

    public static defaultProps: Partial<Props> = {
        value: 'BALANCED',
        title: '',
    }

    public render(): JSX.Element {
        return (
            <div>
                <span style={this.style.title}>
                    {this.props.title}:&nbsp;
                </span>
                <span style={this.style.text}>
                    {this.props.value}
                </span>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/components/BalanceValue.tsx